import { getInstance } from '#/auth';

/**
 * rpcHeaders will create a new dictionary with a bearer token for the user, and account/project ids filled from current route.
 * @param {*} state the store state containing the data necessary for header injection.
 */
export default async function rpcHeaders(state, injectAccount = true, injectProject = true) {
  try {
    const idToken = await getInstance().getTokenSilently();
    const metadata = {
      Authorization: `bearer ${idToken}`,
    };
    if (injectAccount) {
      metadata.account = state.activeWorkspaceId;
      // metadata.account = state.projects[state.activeProjectId].accountId;
    }
    if (injectProject) {
      metadata.project = state.activeProjectId;
    }
    return Promise.resolve(metadata);
  } catch (error) {
    console.log('error retreiving user headers ', error);
    return Promise.reject(error);
  }
}
